import React, { useEffect } from 'react';
import { Route, Redirect, useLocation } from 'react-router-dom';
import firebaseApp from '../firebase-app';
import { useUserAuth } from '../contexts/auth';
import Menu from './menu/menu';
import Loading from './loading';
import ErrorPage from './common/error-page';
import { canAccessFotbollPlay } from './scenes/fotbollplay/access';

interface Props {
  component: any;
  path: string;
  exact?: boolean;
  [x: string]: any;
}

export default function PrivateRoute({ component: RouteComponent, path, exact, ...rest }: Props) {
  const {
    currentUser,
    isSuperAdmin,
    isStatsAdmin,
    isTeamAdmin,
    loadingCurrentUser,
    logout,
    hasTeamAccess,
  } = useUserAuth();
  const location = useLocation();

  useEffect(() => {
    if (location) {
      firebaseApp.logEvent('page_view');
    }
  }, [location]);

  const noAccess = !isSuperAdmin && !isStatsAdmin && !isTeamAdmin;

  return (
    <Route
      {...rest}
      render={(routeProps) => {
        if (loadingCurrentUser) {
          return <Loading />;
        }

        // User needs to login
        if (!currentUser) {
          return <Redirect to="/login" />;
        }

        if (noAccess) {
          return (
            <ErrorPage
              title="Ditt konto har inte tillgång till superadmin"
              message={
                <>
                  <p>
                    Du är inloggad som {currentUser?.email}, kontakta vår support på{' '}
                    <a href="mailto:support@svenskelitfotboll.se">support@svenskelitfotboll.se</a>{' '}
                    för hjälp.
                  </p>
                  <p>
                    <button onClick={logout}>Logga ut</button>
                  </p>
                </>
              }
            />
          );
        }

        // Team access denied
        if (path === '/scene-config/:id') {
          const teamPathNameId = rest.computedMatch.params.id;

          if (!hasTeamAccess(teamPathNameId)) {
            return <Redirect to="/account" />;
          }
        }

        if (path === '/fotbollplay/:id') {
          const teamPathNameId = rest.computedMatch?.params?.id;

          if (!canAccessFotbollPlay({ teamAbbrv: teamPathNameId, isSuperAdmin, hasTeamAccess })) {
            return <Redirect to="/account" />;
          }
        }

        return (
          <>
            <Menu />
            <RouteComponent {...rest} {...routeProps} />
          </>
        );
      }}
    />
  );
}
